import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../pages/Home'
import SubmitSuccess from '../pages/SubmitSuccess'
Vue.use(VueRouter)

const router = new VueRouter({
  mode:'hash',
  routes:[
    {
      path:'',
      component:Home,
      name:'Home'
    },
    {
      path:'/success',
      component:SubmitSuccess,
      name:'Success'
    }
  ]
})

export default router